module.exports = __webpack_public_path__ + "img/3.9bb94bce.jpg";